(function() {
  // Override the theme's tab handler for duplicate sections
  function initGbaTabs() {
    document.querySelectorAll('.gba-tab-section-wapper').forEach(function(section, sectionIndex) {
      
      // Skip first section - it works fine natively
      if (sectionIndex === 0) return;

      section.querySelectorAll('[data-t4s-tab-item]').forEach(function(link) {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          const targetId = link.getAttribute('href').replace('#', '');
          const targetContent = section.querySelector('#' + targetId);
          if (!targetContent) return;

          console.log('GBA: Tab clicked ->', targetId);

          // Update active tab link UI
          section.querySelectorAll('[data-t4s-tab-item]').forEach(l => l.classList.remove('t4s-active'));
          link.classList.add('t4s-active');

          // Update active content
          section.querySelectorAll('.t4s-tab-content2').forEach(c => c.classList.remove('t4s-active'));
          targetContent.classList.add('t4s-active');
          section.setAttribute('data-tab-active', targetId);

          // If already loaded, just resize slider
          if (targetContent.classList.contains('lazyloadt4sed')) {
            console.log('GBA: Already loaded, resizing ->', targetId);
            setTimeout(function() {
              targetContent.querySelectorAll('[data-flickityt4s-js].flickityt4s-enabled').forEach(function(slider) {
                try {
                  const flkty = Flickityt4s.data(slider);
                  if (flkty) { flkty.resize(); flkty.reloadCells(); }
                } catch(e) {}
              });
            }, 100);
            return;
          }

          // Need to load - fetch manually using the section's own URLs
          const renderUrl = targetContent.getAttribute('data-rendert4s');
          const sectionUrl = targetContent.getAttribute('data-set4surl');
          if (!renderUrl) return;

          console.log('GBA: Fetching ->', renderUrl + sectionUrl);

          // Show loading
          targetContent.innerHTML = '<div class="lds_bginfinity t4s-pr"></div>';

          fetch(renderUrl + sectionUrl)
            .then(r => r.text())
            .then(function(html) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');

              // Find the matching content panel in the response
              const newContent = doc.querySelector('#' + targetId);
              if (newContent) {
                targetContent.innerHTML = newContent.innerHTML;
              } else {
                // Fallback: grab main content area
                const fallback = doc.querySelector('.t4s-tab-contents2 > div:first-child, .tabs-content-wrap');
                if (fallback) targetContent.innerHTML = fallback.innerHTML;
              }

              targetContent.classList.remove('lazyloadt4sing');
              targetContent.classList.add('lazyloadt4sed');
              targetContent.classList.add('t4s-active');

              console.log('GBA: Content loaded ->', targetId);

              // Initialize Flickity on new sliders
              setTimeout(function() {
                targetContent.querySelectorAll('[data-flickityt4s-js]:not(.flickityt4s-enabled)').forEach(function(slider) {
                  try {
                    const opts = JSON.parse(slider.getAttribute('data-flickityt4s-js'));
                    new Flickityt4s(slider, opts);
                    console.log('GBA: Flickity initialized ->', targetId);
                  } catch(err) {
                    console.log('GBA: Flickity error ->', err);
                  }
                });
              }, 200);
            })
            .catch(function(err) {
              console.log('GBA: Fetch error ->', err);
            });
        }, true); // useCapture=true to run before theme's listener
      });
    });
  }

  // Run after page fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGbaTabs);
  } else {
    initGbaTabs();
  }
})();

//***************************** custom cart cyo *************************************************************************//

function removeCYOProductHrefs() {
  const cartItems = document.querySelectorAll('.t4s-mini_cart__item, [data-cart-item], .t4s-page_cart__infos');

  cartItems.forEach(item => {
    const titleLink = item.querySelector('.t4s-mini_cart__title, .t4s-page_cart__title');
    const imageLink = item.querySelector('.t4s-mini_cart__img, .t4s-page_cart__img');
    const hasBoxProperty = item.querySelector('.t4s-product-details__item-label strong');

    if (titleLink) {
      const titleText = titleLink.textContent.trim();
      const isCYO = titleText.startsWith('CYO');
      const hasBox = hasBoxProperty && hasBoxProperty.textContent.trim() === 'Box:';

      if (isCYO || hasBox) {
        if (titleLink.hasAttribute('href')) {
          titleLink.removeAttribute('href');
          titleLink.style.cursor = 'default';
          titleLink.style.textDecoration = 'none';
          titleLink.style.pointerEvents = 'none';
        }
        if (imageLink && imageLink.hasAttribute('href')) {
          imageLink.removeAttribute('href');
          imageLink.style.cursor = 'default';
          imageLink.style.pointerEvents = 'none';
        }
      }
    }
  });
}

// Prevent clicks on CYO product links (backup protection)
document.addEventListener('click', function (e) {
  const titleLink = e.target.closest('.t4s-mini_cart__title, .t4s-page_cart__title');
  const imageLink = e.target.closest('.t4s-mini_cart__img, .t4s-page_cart__img');

  if (titleLink || imageLink) {
    const cartItem = e.target.closest('.t4s-mini_cart__item, [data-cart-item], .t4s-page_cart__infos');
    if (cartItem) {
      const title = cartItem.querySelector('.t4s-mini_cart__title, .t4s-page_cart__title');
      const hasBoxProperty = cartItem.querySelector('.t4s-product-details__item-label strong');
      if (title) {
        const titleText = title.textContent.trim();
        const isCYO = titleText.startsWith('CYO');
        const hasBox = hasBoxProperty && hasBoxProperty.textContent.trim() === 'Box:';
        if (isCYO || hasBox) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }
    }
  }
}, true);

document.addEventListener('DOMContentLoaded', removeCYOProductHrefs);
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(removeCYOProductHrefs, 100);
  setTimeout(removeCYOProductHrefs, 500);
  setTimeout(removeCYOProductHrefs, 1000);
});
document.addEventListener('cart:updated', removeCYOProductHrefs);
document.addEventListener('cart:refresh', removeCYOProductHrefs);

// Cart container observer — scoped, not body-wide
const cartContainer = document.querySelector('[data-cart-items], .t4s-mini_cart__items');
if (cartContainer) {
  new MutationObserver(removeCYOProductHrefs).observe(cartContainer, { childList: true, subtree: true });
}

const cartPage = document.querySelector('.t4s-page_cart, .cart-page, #CartPage');
if (cartPage) {
  new MutationObserver(removeCYOProductHrefs).observe(cartPage, { childList: true, subtree: true });
}

const drawerObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (mutation.attributeName === 'class' || mutation.attributeName === 'style' || mutation.attributeName === 'hidden') {
      setTimeout(removeCYOProductHrefs, 50);
      setTimeout(removeCYOProductHrefs, 200);
    }
  });
});

document.querySelectorAll('.t4s-mini_cart, #CartDrawer, [data-cart-drawer], .cart-drawer, .t4s-page_cart').forEach(function (wrapper) {
  drawerObserver.observe(wrapper, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
});

// Body class observer — attributes only, safe (won't fire on DOM changes)
new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (mutation.attributeName === 'class') {
      const bodyClasses = document.body.className;
      if (bodyClasses.includes('cart') || bodyClasses.includes('drawer')) {
        setTimeout(removeCYOProductHrefs, 50);
      }
    }
  });
}).observe(document.body, { attributes: true, attributeFilter: ['class'] });

if (window.location.pathname.includes('/cart')) {
  setTimeout(removeCYOProductHrefs, 100);
  setTimeout(removeCYOProductHrefs, 500);
}

// custom cart cyo - end


//***************************** cyo bundle creator easify app js *************************************************************************//

(function () {
  const STEP = 10;
  const gridsState = new Map();
  let isPaused = false;

  function isExcluded(product) {
    if (product.getAttribute('data-excluded') === 'true') return true;

    const inlineDisplay = product.style.display;
    if (!inlineDisplay || inlineDisplay === '') {
      const computedDisplay = window.getComputedStyle(product).display;
      if (computedDisplay === 'none') return true;
    }

    const titleEl = product.querySelector('.productContent-module__product_information_title__em');
    if (!titleEl || titleEl.textContent.trim() === '') return false;
    const titleText = titleEl.textContent.trim().toLowerCase();
    return (
      titleText.includes('cyo') ||
      titleText.includes('voucher') ||
      titleText.includes('eGift') ||
      titleText.includes('create your own')
    );
  }

  function isTitleLoaded(product) {
    const titleEl = product.querySelector('.productContent-module__product_information_title__em');
    return titleEl && titleEl.textContent.trim() !== '';
  }

  function getAllProducts(gridWrapper) {
    return Array.from(gridWrapper.querySelectorAll('.productContent-module__card_product__Hh'));
  }

  function getEligibleProducts(gridWrapper) {
    return getAllProducts(gridWrapper).filter(p => p.getAttribute('data-excluded') !== 'true');
  }

  function hideExcludedProducts(gridWrapper) {
    getAllProducts(gridWrapper).forEach(function (product) {
      if (product.getAttribute('data-excluded') === 'true') return;
      if (isExcluded(product)) {
        product.style.display = 'none';
        product.setAttribute('data-excluded', 'true');
      }
    });
  }

  function applyVisibility(gridWrapper, visibleItems) {
    const eligible = getEligibleProducts(gridWrapper);
    eligible.forEach((product, index) => {
      product.style.display = index < visibleItems ? '' : 'none';
    });
  }

  function updateButtonVisibility(gridWrapper, state) {
    if (!state.btnElement) return;
    const eligible = getEligibleProducts(gridWrapper);
    const btn = state.btnElement.querySelector('button');

    if (window.innerWidth >= 1025) {
      const el = document.querySelector('.accordionElement-module__accordionContentContainer__nF');
      if (el) {
        el.style.marginBottom = '150px';
        el.style.marginTop = '100px';
        el.style.gap = '20px';
      }
    }

    if (eligible.length > state.visibleItems) {
      state.btnElement.style.display = 'block';
      if (btn) btn.textContent = 'Load More Products';
    } else {
      state.btnElement.style.display = 'none';
    }
  }

  function waitForTitles(gridWrapper, callback) {
    const maxWait = 10000;
    const interval = 100;
    let elapsed = 0;

    const check = setInterval(() => {
      const allProducts = getAllProducts(gridWrapper);
      const allTitlesLoaded = allProducts.length > 0 && allProducts.every(p => isTitleLoaded(p));

      if (allTitlesLoaded) {
        clearInterval(check);
        callback();
        return;
      }

      elapsed += interval;
      if (elapsed >= maxWait) {
        clearInterval(check);
        callback();
      }
    }, interval);
  }

  function initGrid(gridWrapper) {
    if (!gridsState.has(gridWrapper)) {
      gridsState.set(gridWrapper, {
        visibleItems: STEP,
        buttonAdded: false,
        btnElement: null,
        waitingForTitles: false
      });
    }

    const state = gridsState.get(gridWrapper);
    if (state.waitingForTitles) return;
    state.waitingForTitles = true;

    waitForTitles(gridWrapper, () => {
      state.waitingForTitles = false;
      hideExcludedProducts(gridWrapper);

      const eligible = getEligibleProducts(gridWrapper);
      if (eligible.length === 0) return;

      applyVisibility(gridWrapper, state.visibleItems);

      if (eligible.length > STEP && !state.buttonAdded) {
        const btnWrapper = document.createElement('div');
        btnWrapper.className = 'cyo-load-more-wrapper';
        btnWrapper.style.cssText = 'text-align:center; margin: 30px 0; width:100%; clear:both;';
        btnWrapper.innerHTML = '<button class="cyo-load-more-btn" style="cursor:pointer; padding: 12px 35px; background:#000; color:#fff; border:none; border-radius:4px; font-weight:bold; font-size:16px;">Load More Products</button>';

        const btn = btnWrapper.querySelector('button');
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          if (btn.disabled) return;
          btn.disabled = true;
          isPaused = true;
          hideExcludedProducts(gridWrapper);
          state.visibleItems += STEP;
          applyVisibility(gridWrapper, state.visibleItems);
          btn.disabled = false;
          isPaused = false;
          updateButtonVisibility(gridWrapper, state);
        });

        gridWrapper.after(btnWrapper);
        state.buttonAdded = true;
        state.btnElement = btnWrapper;
      }

      updateButtonVisibility(gridWrapper, state);
    });
  }

  // Debounced observer — safe because initGrid guards re-entry via waitingForTitles flag
  let debounceTimer;
  new MutationObserver(() => {
    if (isPaused) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      document.querySelectorAll('.cyo-product-grid-wapper').forEach(grid => initGrid(grid));
    }, 200);
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'complete') {
    document.querySelectorAll('.cyo-product-grid-wapper').forEach(grid => initGrid(grid));
  } else {
    window.addEventListener('load', () => {
      document.querySelectorAll('.cyo-product-grid-wapper').forEach(grid => initGrid(grid));
    });
  }
})();


// Add to box button trigger on product card
document.addEventListener('click', function (e) {
  const productCard = e.target.closest('.cyo-product-grid-wapper .productContent-module__card_product__Hh');
  if (!productCard) return;

  const isExcluded =
    e.target.closest('.cyo-product-grid-wapper .addToBoxButton-module__button_atc__zo') ||
    e.target.closest('.cyo-product-grid-wapper .productContent-module__icon_search_product__Lx') ||
    e.target.closest('.cyo-product-grid-wapper a') ||
    e.target.closest('.cyo-product-grid-wapper button');

  if (isExcluded) return;

  const addToBoxBtn = productCard.querySelector('.cyo-product-grid-wapper .addToBoxButton-module__button_atc_content__wU');
  if (addToBoxBtn) {
    addToBoxBtn.dispatchEvent(new MouseEvent('click', { view: window, bubbles: true, cancelable: true }));
  }
});

document.querySelectorAll('#tb-bulk-radio input[type="radio"]').forEach(radio => {
  radio.addEventListener('mousedown', function (e) {
    if (this.checked) e.preventDefault();
  });
});

const nextBtnObserver = new MutationObserver(() => {
  const btn = document.querySelector('.review-summery .BOX_REVIEW_PAGE_CREATE_NEW_BOX_BUTTON_TS span');
  if (btn && btn.textContent === 'Create New Box') {
    btn.textContent = 'Create New';
  }
});

nextBtnObserver.observe(document.body, { childList: true, subtree: true });


// Bulk app - download button injection
// FIX: injected flag prevents DOM append from re-triggering observer
(function () {
  let injected = false;

  function injectDownloadButton() {
    if (injected) return;
    const multiAddress = document.getElementById('tb-bulk-multi-address');
    if (!multiAddress) return;
    if (multiAddress.querySelector('.multi-address-downlaod-wapper')) return;

    injected = true;

    const wrapper = document.createElement('div');
    wrapper.className = 'multi-address-downlaod-wapper';

    const link = document.createElement('a');
    link.href = 'https://cdn.shopify.com/s/files/1/0517/2061/8175/files/Hampers-Galore-Corporate-Bulk-Order-Form-2026.xlsx?v=1771904819';
    link.className = 'cgb-download-template-btn';
    link.setAttribute('download', '');
    link.textContent = 'Download bulk order form (Excel)';

    wrapper.appendChild(link);
    multiAddress.appendChild(wrapper);
  }

  new MutationObserver(injectDownloadButton).observe(document.body, { childList: true, subtree: true });
  injectDownloadButton();
})();


// Next button configuration
// FIX: debounced observer + guard flag on each button prevents re-processing
(function () {
  function hideCYOProducts() {
    document.querySelectorAll('.gba-bulk-accodian .productContent-module__card_product__Hh[data-product-id]').forEach(function (card) {
      const titleEl = card.querySelector('.productContent-module__product_information_title__em');
      if (titleEl) {
        const titleText = titleEl.textContent.trim().toLowerCase();
        if (
          titleText.includes('cyo') ||
          titleText.includes('voucher') ||
          titleText.includes('eGift Card') ||
          titleText.includes('create your own')
        ) {
          card.style.display = 'none';
        }
      }
    });
  }

  function moveNextButtons() {
    const allButtons = document.querySelectorAll('.style1Header-module__item__0i');
    const buttonMap = [
      { text: 'Step 2 - Branding Options',          nextLabel: 'Next : Branding Options',         target: '#gba-accdian-item-wapper-2' },
      { text: 'Step 2.5 - Add a Photo & Message',   nextLabel: 'Next : Add a Photo & Message',     target: '#gba-accdian-item-wapper-3' },
      { text: 'Step 3 - Add Greeting Card Message', nextLabel: 'Next : Add Greeting Card Message', target: '#gba-accdian-item-wapper-4' },
      { text: 'Step 4 - Add Recipient Adresses',    nextLabel: 'Next : Add Recipient Adresses',    target: '#gba-accdian-item-wapper-5' },
    ];

    buttonMap.forEach(function ({ text, nextLabel, target }) {
      const button = Array.from(allButtons).find(btn => btn.textContent.trim().includes(text));
      const wrapper = document.querySelector(target);

      // Guard: skip if already moved — prevents re-triggering loop
      if (!button || !wrapper || button.classList.contains('gba-moved-next-btn')) return;

      button.classList.add('gba-moved-next-btn');
      const labelEl = button.querySelector('div');
      if (labelEl) labelEl.textContent = nextLabel;

      button.addEventListener('click', function () {
        setTimeout(function () {
          const scrollEl = document.querySelector(target);
          if (scrollEl) {
            const top = scrollEl.getBoundingClientRect().top + window.scrollY - 130;
            window.scrollTo({ top, behavior: 'smooth' });
          }
        }, 300);
      });

      const btnWrapper = document.createElement('div');
      btnWrapper.classList.add('gba-moved-next-btn-wapper');
      btnWrapper.appendChild(button.parentNode.removeChild(button));
      wrapper.appendChild(btnWrapper);
    });
  }

  function init() {
    hideCYOProducts();
    moveNextButtons();

    let debounce;
    new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        hideCYOProducts();
        moveNextButtons();
      }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


// Review summary body class toggle
// FIX: disconnect before toggling class, reconnect after — prevents self-triggering loop
(function () {
  let lastState = null;

  const observer = new MutationObserver(function () {
    const shouldAdd = !!document.getElementById('Review-bulk-order-header');
    if (shouldAdd === lastState) return; // no change, do nothing
    lastState = shouldAdd;
    observer.disconnect();
    document.body.classList.toggle('review-summery', shouldAdd);
    observer.observe(document.body, { childList: true, subtree: true });
  });

  // Initial run
  lastState = !!document.getElementById('Review-bulk-order-header');
  document.body.classList.toggle('review-summery', lastState);
  observer.observe(document.body, { childList: true, subtree: true });
})();

// cyo bundle creator easify app js - end


//***************************** Title trimming *************************************************************************//

function getMaxLength() {
  const width = window.innerWidth;
  if (width >= 1396) return 60;
  if (width >= 1000) return 40;
  if (width >= 768) return 35;
  return 30;
}

function truncateTitles() {
  const maxLength = getMaxLength();

  document.querySelectorAll('.t4s-product-title a').forEach(title => {
    // Store original text once
    if (!title.getAttribute('data-original-text')) {
      title.setAttribute('data-original-text', title.textContent.trim());
    }

    const text = title.getAttribute('data-original-text');
    const truncated = text.length > maxLength ? text.substring(0, maxLength) + '...' : text;

    // Only write to DOM if value changed — prevents observer re-triggering
    if (title.textContent !== truncated) {
      title.textContent = truncated;
    }
  });
}

// FIX: only react to addedNodes (new pagination content), ignore text/attribute mutations
(function () {
  let truncateDebounce;
  new MutationObserver(function (mutations) {
    const hasNewNodes = mutations.some(m => m.addedNodes.length > 0);
    if (!hasNewNodes) return;
    clearTimeout(truncateDebounce);
    truncateDebounce = setTimeout(truncateTitles, 100);
  }).observe(document.body, { childList: true, subtree: true });
})();

// Re-run on tab click
document.querySelectorAll('.t4s-tab-item a').forEach(tab => {
  tab.addEventListener('click', () => setTimeout(truncateTitles, 300));
});

// Run on load + resize
truncateTitles();
window.addEventListener('resize', truncateTitles);


//***************************** Info title trimming *************************************************************************//

function limitInfoTitleOnly() {
  const isTargetSize = window.innerWidth >= 1024 && window.innerWidth <= 1450;

  document.querySelectorAll('.info').forEach(el => {
    if (!el.dataset.full) {
      el.dataset.full = el.innerHTML.trim();
    }

    if (!isTargetSize) {
      el.innerHTML = el.dataset.full;
      return;
    }

    const temp = document.createElement('div');
    temp.innerHTML = el.dataset.full;

    const priceEl = temp.querySelector('.info-price');
    if (!priceEl) return;

    const fullTitle = temp.childNodes[0].textContent.trim();
    const maxChars = 26;
    const shortTitle = fullTitle.length > maxChars ? fullTitle.slice(0, maxChars) + '...' : fullTitle;

    el.innerHTML = shortTitle + priceEl.outerHTML;
  });
}

limitInfoTitleOnly();
window.addEventListener('resize', limitInfoTitleOnly);


//***************************** Upsell slider dots to one line *************************************************************************//

(function () {
  function scrollActiveDot() {
    const container = document.querySelector('.flickityt4s-page-dots');
    if (!container) return;

    const slider = document.querySelector('.flickityt4s-slider');
    if (!slider) return;

    const slides = Array.from(slider.querySelectorAll('.t4s-col-item'));
    const selectedIndex = slides.findIndex(s => s.classList.contains('is-selected'));
    if (selectedIndex === -1) return;

    const dots = Array.from(container.querySelectorAll('.dot'));
    const targetDot = dots[selectedIndex];
    if (!targetDot) return;

    const targetScroll = targetDot.offsetLeft - (container.offsetWidth / 2) + (targetDot.offsetWidth / 2);
    container.scrollLeft = targetScroll;
  }

  const slider = document.querySelector('.flickityt4s-slider');
  if (slider) {
    new MutationObserver(scrollActiveDot).observe(slider, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  const dots = document.querySelector('.flickityt4s-page-dots');
  if (dots) {
    new MutationObserver(scrollActiveDot).observe(dots, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.flickityt4s-prev-next-button') || e.target.closest('.dot')) {
      setTimeout(scrollActiveDot, 100);
      setTimeout(scrollActiveDot, 300);
    }
  });

  setTimeout(scrollActiveDot, 500);
})();


// (function () {
//   'use strict';

//   var overlay = document.getElementById('t4s-wp-overlay-section-welcome-popup');

//   if (!overlay) return;

//   var welcomeWasShown = overlay.classList.contains('is--active');

//   function getExitWrappers() {
//     return document.querySelectorAll('.t4s-exit_pp_wrapper');
//   }

//   function hideExitPopup() {
//     getExitWrappers().forEach(function (el) { el.style.display = 'none'; });
//   }

//   function restoreScroll() {
//     // Remove overflow lock from both html and body
//     document.documentElement.style.overflow = '';
//     document.documentElement.style.marginRight = '';
//     document.documentElement.classList.remove('is-opening-mfp');
//     document.body.style.overflow = '';
//     document.body.style.marginRight = '';
//   }

//   // Watch for welcome popup class changes
//   var overlayObserver = new MutationObserver(function () {
//     if (overlay.classList.contains('is--active')) {
//       welcomeWasShown = true;
//       hideExitPopup();
//     } else if (welcomeWasShown) {
//       // Welcome popup just closed — restore scroll and block exit popup
//       hideExitPopup();
//       restoreScroll();
//     }
//   });

//   overlayObserver.observe(overlay, { attributes: true, attributeFilter: ['class'] });

//   // Watch for exit popup injected into DOM — block it if welcome was ever shown
//   var bodyObserver = new MutationObserver(function () {
//     if (welcomeWasShown) {
//       hideExitPopup();
//       restoreScroll();
//     }
//   });

//   bodyObserver.observe(document.body, { childList: true, subtree: true });

//   // Also watch html tag for is-opening-mfp being added while welcome was shown
//   var htmlObserver = new MutationObserver(function () {
//     if (welcomeWasShown && document.documentElement.classList.contains('is-opening-mfp')) {
//       restoreScroll();
//     }
//   });

//   htmlObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });

//   // Run once on load
//   if (welcomeWasShown) {
//     hideExitPopup();
//   }

// })();